import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import ExcelExport from 'export-xlsx';
import { SETTINGS_FOR_EXPORT } from '../../xlsxSettings';
import * as XLSX from 'xlsx';
import { getRutDv, formatterRut, cleanRut, validateRut } from "chilean-formatter";

@Component({
  selector: 'app-controlusuarios',
  templateUrl: './controlusuarios.component.html',
  styleUrls: ['./controlusuarios.component.scss']
})
export class ControlusuariosComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload: any;

  clientes: any[] = []
  instalaciones: any[] = []
  instalacionesFiltradas: any[] = []
  usuarios: any[] = []
  usuario: any;

  idClienteSeleccionado: string = ''
  idInstalacionSeleccionada: string
  modalCargaMasiva: boolean = false

  demo: any;
  isExcelFile: boolean;

  rutNoValidos: ['11111111-1', '22222222-2', '33333333-3', '44444444-4', '55555555-5', '66666666-6', '77777777-7', '88888888-8', '99999999-9']

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone,
  ) {
    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    this.getClientes()
    this.getInstalaciones() 

  }

  confirm(bloqueado: boolean, idusuario) {
    let msg = '¿Estás seguro de BLOQUEAR este usuario?'
    const usuario = this.usuarios.find(e => e._id == idusuario)

    if (bloqueado)
      msg = '¿Estás seguro de HABILITAR este usuario?'
    this.confirmationService.confirm({
      message: msg,


      accept: () => {
        this.http.updateUsuarioCedulaService(idusuario, !bloqueado).subscribe((data: any) => {
          console.log('data', data);

          this.messageService.add({
            severity: "success",
            summary: 'Perfecto!',
            detail: 'El usuario ha sido modificado'
          });

          this.getUsuarios()

        })
      }
    });
  }

  ngOnInit(): void {

  }

  async getInstalaciones(): Promise<void> {
    this.instalaciones = await this.http.getinstalacionesByEmpresaService(this.usuario.Empresa._id);
    console.log('instalaciones', this.instalaciones);
  }

  filtraInstalaciones(event) {
    console.log('filtraInstalaciones');
    console.log('event', event);
    this.instalacionesFiltradas = this.instalaciones.filter(e => e.Cliente._id == event.value)
  }

  inputArchivo: string;
  muestraData: boolean = false;
  botonReady: boolean = false;
  dataExcel: any = null
  cantidadDatosEnExcel: number = 0;

  archivoSeleccionado(event) {
    console.log('enn archivoSeleccionado');
    console.log(event);

    const target: DataTransfer = <DataTransfer>(event.target);
    this.isExcelFile = !!event.files[0].name.match(/(.xls|.xlsx)/);

    if (!this.isExcelFile) {
      console.log('No es archivo Excel');
    }

    // let aux = event.target.value.split('\\')
    // this.inputArchivo = aux[2]

    //this.spinnerEnabled = true;
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.dataExcel = XLSX.utils.sheet_to_json(ws);

      // Habilita botón si se seleccionó Comunidad y se cargó el archivo
      this.botonReady = this.isExcelFile && this.compruebaCampos()
    };

    reader.readAsBinaryString(event.files[0]);

    reader.onloadend = (e) => {
      // if (this.compruebaLongitudDatos()) {
      //   this.cantidadDatosEnExcel = this.dataExcel.length
      // }
    }

    this.inputArchivo = null;
    this.fileUpload.clear()
  }

  compruebaCampos(): boolean {
    let data = this.dataExcel[0]
    let salida = true
    if (!data.hasOwnProperty("NOMBRE") || !data.hasOwnProperty("RUT") || !data.hasOwnProperty("BLOQUEADO")) {
      console.log('no existe');
      salida = false
    } else {
      //this.cantidadDatosEnExcel = this.dataExcel.length
    }
    if (!salida) {

      this.messageService.add({
        severity: "error",
        summary: 'Error de formato',
        detail: 'El archivo no contiene los campos necesarios'
      });

    }
    //Reviso si los RUT son válidos
    this.dataExcel.forEach((element, index) => {
      let aux = validateRut(element.RUT)

      if (!aux || element.RUT.toString().length < 8 || element.RUT == 11111111 || element.RUT == '11111111-1') {

        this.messageService.add({
          severity: "error",
          summary: 'RUT incorrecto',
          detail: 'El RUT ' + element.RUT.toString() + ' no es válido'
        });

        let n = this.dataExcel.findIndex((el) => el.RUT === element.RUT)
        this.dataExcel.splice(n, 1)
      }

      element.NombreCompleto = element.NOMBRE
      element._id = element.RUT       // Este modelo usa el rut como _id
      element.Bloqueado = false
      if (element.BLOQUEADO == 'SI')
        element.Bloqueado = true

      delete element.NOMBRE
      delete element.RUT
      delete element.BLOQUEADO
    });

    console.log('Válidos:', this.dataExcel);

    this.cantidadDatosEnExcel = this.dataExcel.length

    return salida
  }

  abreCargaMasiva() {
    this.modalCargaMasiva = true
  }

  guardar() {
    this.http.newUsuarioCedulaWEBService(this.dataExcel, this.idClienteSeleccionado, this.idInstalacionSeleccionada).subscribe((data: any) => {
      console.log('data', data);

      this.messageService.add({
        severity: "success",
        summary: 'Prefecto!',
        detail: 'Los datos fueron agregados satisfactoriamente'
      });

      this.dataExcel = []
      this.modalCargaMasiva = false
    })
  }

  async getUsuarios(): Promise<void> {
    this.usuarios = await this.http.getUsuariosAccesosByClienteService(this.idClienteSeleccionado);
    console.log('usuarios', this.usuarios);

    this.ngZone.run(() => {
      console.log('ngZone');
    })
  }

  async getClientes(): Promise<void> {
    const aux = await this.http.getclientesbyEmpresaService(this.usuario.Empresa._id);
    console.log('aux', aux);

    if (this.usuario.TipoUsuario == 'USER') {
      this.clientes = aux.filter(e => e._id == this.usuario.Cliente)
    } else

      this.clientes = aux

    if (!this.idClienteSeleccionado) {
      this.idClienteSeleccionado = this.clientes[0]._id
      // this.clienteSeleccionado = this.clientes[0]
      this.http.setLocalstorage('idClienteSeleccionado', this.idClienteSeleccionado)
    }

    // this.ngZone.run(() => {
    //   console.log('ngZone');
    // })
  }

  limpiaFormulario() {
    this.modalCargaMasiva = false
  }

  descargar() {
    console.log('descargar');
    const excelExport = new ExcelExport();

    let _usuarios = []
    this.usuarios.forEach(e => {

      let bloqueado = 'BLOQUEADO'
      if (!e.Bloqueo.Bloqueado)
        bloqueado = 'HABILITADO'

      let inst = '---'
      let fecha = '---'
      if (e.UltimoIngreso) {
        inst = e.UltimoIngreso.Instalacion.Nombre
        fecha = new Date(e.UltimoIngreso.FechaAcceso).toLocaleString()
      }

      _usuarios.push({
        Cliente: e.Cliente.Nombre,
        Instalacion: inst,
        Usuario: e.UsuarioCedula.NombreCompleto,
        Rut: e.UsuarioCedula._id,
        AutorizadoPor: e.AutorizadoPor,
        FechaAcceso: fecha,
        Bloqueado: bloqueado,
        SeDirigeA: e.SeDirigeA,
      })
    });



    let data = [{ data: _usuarios }]
    console.log('SETTINGS_FOR_EXPORT', SETTINGS_FOR_EXPORT);
    // let now = new Date()
    // let d = now.getDate()
    // let M = now.getMonth() + 1
    // let y = now.getFullYear()
    // let h = now.getHours()
    // let m = now.getMinutes()
    let filename = 'Usuarios_' + _usuarios[0].Cliente
    SETTINGS_FOR_EXPORT.fileName = filename

    SETTINGS_FOR_EXPORT.workSheets[0].sheetName = 'Accesos'

    let def = [
      {
        name: 'Usuario',
        key: 'Usuario',
        width: 30,
      },
      {
        name: 'RUT',
        key: 'Rut',
        width: 15,
      },
      {
        name: 'Instalación últ. acceso',
        key: 'Instalacion',
        width: 25,
      },
      {
        name: 'Fecha últ. acceso',
        key: 'FechaAcceso',
        width: 20,
      },
      {
        name: 'Cliente',
        key: 'Cliente',
        width: 25,
      },
      {
        name: 'SeDirigeA',
        key: 'SeDirigeA',
        width: 20,
      },
      {
        name: 'AutorizadoPor',
        key: 'AutorizadoPor',
        width: 20,
      },
      {
        name: 'Bloqueado',
        key: 'Bloqueado',
        width: 15,
      }
    ]

    SETTINGS_FOR_EXPORT.workSheets[0].tableSettings.data.headerDefinition = def
    excelExport.downloadExcel(SETTINGS_FOR_EXPORT, data);

  }
}
